export enum DataHooks {
  ROOT = 'online-badge-root',
}
